import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

export const useGetCouponCodeReport = () => {
  const Api = useApi()
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const initialFilters = {
    page: 1,
    limit: 30,
    sort_by: 'total_discount/-1',
    search: '',
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), 
  }

  const {filters, onSearch, onSortingChange, onPageChange, onDateChange} = useFilters(
    initialFilters,
    {
      sortType: 'number',
    }
  )

  const {data: response, isFetching} = Api.useGetQuery(
    '/analytics/coupon-discount/report/coupon-code',
    {
      queryId: 'coupon-code-report',
      filters,
      isToast: false,
      isErrorPageRedirection: false,
    }
  )

  const onDownloadCsv = async (payload: any) => {
    try {
      const res = await Api.post('/analytics/coupon-discount/report/coupon-code/download', payload)
      return res?.data?.message || ''
    } catch (error) {
      console.error('Error downloading CSV:', error)
      return ''
    }
  }

  return {
    reportData: response?.data || [],
    isLoading: isFetching,
    filters,
    onSearch,
    onSortingChange,
    onPageChange,
    handleCouponCodeReportDateChange: onDateChange,
    pagination: response?.meta?.pagination || {},
    onDownloadCsv,
  }
}
